/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import { injectable } from 'inversify';
import { TAgent, getAgent } from './agent';
import { StorageModule } from '@vlinder-web/storage-module-react';
const is = require('is_js');
const lookup = require('country-code-lookup');

@injectable()
export class BuyInsurancePageService {
  static displayName = 'BuyInsurancePageService';
  public agent: TAgent;
  private kycFormData: any;
  private policyData: any;
  private termsData: any;
  private intendedPurpose: any;
  private policyOptions: any;
  private country: string;
  private policyHolder: any;
  private dob:string;

  constructor() {
    this.agent = getAgent();
    this.kycFormData = this.kycFormData;
    this.policyData = this.policyData;
    this.termsData = this.termsData;
    this.intendedPurpose = this.intendedPurpose;
    this.policyOptions = this.policyOptions;
    this.country = this.country;
    this.dob = this.dob;
    this.policyHolder = this?.policyHolder;
  }

  private setKycFormData(data: any) {
    this.kycFormData = data;
  }
  private setPolicyData(data: any) {
    this.policyData = data;
  }

  private setPolicyOptions(data: any) {
    this.policyOptions = data;
  }

  private  setDob(data:string){
    this.dob=data;
  }

  private setTermsData(data: any) {
    this.termsData = data;
  }
  private setIntendedPurpose(data: any) {
    this.intendedPurpose = data;
  }

  private resetPolicyData() {
    (this.kycFormData = {}),
      (this.policyData = null),
      (this.policyOptions = null),
      (this.termsData = {}),
      (this.intendedPurpose = {}),
      (this.country = ''),
      (this.policyHolder = {});
      this.dob=null;
  }

  public setKYCFormData(formData: any) {
    this.setKycFormData(formData);
  }

  public setPolicyDetail(policyData: any) {
    this.setPolicyData(policyData);
  }

  public setTermsOfUseData(termsData: any) {
    this.setTermsData(termsData);
  }

  public SubmitIntendedPurpose(data: any) {
    this.setIntendedPurpose(data);
  }

  public onPolicyOptionChange(data: any) {
    this.setPolicyOptions(data);
  }

  public setCountry(data: any) {
    this.country = data;
  }

  public setDateOfBirth(data:string){
    this.setDob(data);
  }

  public getPolicyPreviewData() {
    const storageSrv = StorageModule?.getInstance();
    let holderProfile = storageSrv.get('myProfile', 'session');
    return {
      policyHolder:{
              firstName: this.kycFormData?.firstName ?? holderProfile.firstName,
              lastName: this?.kycFormData?.lastName ?? holderProfile.lastName,
              streetAddress: this.kycFormData?.streetAddress ?? holderProfile?.address?.addressLine1,
              city:this.kycFormData?.city ?? holderProfile?.city,
              country: this.kycFormData?.country ?? holderProfile?.country,
              email: this.kycFormData?.email ?? holderProfile?.email,
              telephone: this.kycFormData?.telephone ?? holderProfile?.primaryContactNo,
              gender: this.kycFormData?.gender ?? holderProfile?.gender,
              aadharNo:this.kycFormData?.aadharNo ?? holderProfile?.aadharNo,
              dob:this.dob,
      },
      beneficiary: {
        firstName: this.kycFormData?.beneficiaryFirstName,
        aadharNo:this.kycFormData?.beneficiaryAadharNo,
        gender:this.kycFormData?.beneficiaryGender,
        lastName: this.kycFormData?.beneficiaryLastName,
        streetAddress: this.kycFormData?.beneficiaryStreetAddress,
        city: this.kycFormData?.beneficiaryCity,
        country: this.kycFormData?.beneficiaryCountry
          ? lookup.byIso(this.kycFormData?.beneficiaryCountry)?.country
          : '-',
        telephone: this.kycFormData?.beneficiaryTelephone,
        email: this.kycFormData?.beneficiaryEmail,
      },
      policyData: this.policyData,
      termsData: this.termsData,
    };
  }

  public getKYCFormData() {
    return this.kycFormData;
  }
  public getIntendedPurpose() {
    return this.intendedPurpose;
  }
  public getDefaultPolicy() {
    return this.policyOptions;
  }
  public resetFormData() {
    this.resetPolicyData();
  }

}
